import PropTypes from 'prop-types';
import React from 'react';
import { swEnabled } from '../engage_cache.js';
import Tooltip from 'react-aria-tooltip';

export default function OfflineBadge({ offlineStatus, toggleOffline }) {
    if (!swEnabled || offlineStatus == null) {
        return <noscript />;
    }
    const { localPages, totalPages, error } = offlineStatus;

    if (error) {
        return (
            <div className="offline-badge error">
                <Tooltip
                    message="Download failed. Click icon to try again."
                    eventType="hover"
                >
                    <button
                        className="cl-icon cl-icon-refresh"
                        onClick={toggleOffline}
                    />
                    <span className="aural">
                        An error occurred while downloading
                    </span>
                </Tooltip>
            </div>
        );
    }

    if (localPages === totalPages) {
        return (
            <div className="offline-badge complete">
                <Tooltip message="Available offline" eventType="hover">
                    <i className="cl-icon cl-icon-check" aria-hidden />
                    <span className="aural">Available offline</span>
                </Tooltip>
            </div>
        );
    }

    const percent = Math.round((100 * localPages) / totalPages);
    const completionMesssage = `${percent}% complete`;

    return (
        <div
            className="offline-badge downloading"
            style={{
                backgroundImage: `linear-gradient(to top, #32D578 ${percent}%, white ${percent +
                    1}%, white 100%)`,
            }}
        >
            <Tooltip message={completionMesssage} eventType="hover">
                <i className="cl-icon cl-icon-refresh spin" aria-hidden />
                <span className="aural">{percent}%</span>
            </Tooltip>
        </div>
    );
}

OfflineBadge.propTypes = {
    offlineStatus: PropTypes.shape({
        totalPages: PropTypes.number.isRequired,
        localPages: PropTypes.number.isRequired,
        error: PropTypes.string,
        deleting: PropTypes.bool,
    }),
    toggleOffline: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/offline_badge.ui.jsx